import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import UserService from '@/services/UserService';
import { bus } from '@/eventBus';
import AccountService from '@/services/AccountService';
export default {
  name: 'Sidebar',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      networkInfo: null,
      channel_id: null,
      user: null,
      search: '',
      filterText: '',
      channelsExpanded: true,
      networksExpanded: false
    };
  },
  computed: {
    sidebarLogo() {
      if (!this.networkInfo) return null;
      return this.networkInfo.profileimage_display || this.networkInfo.logoimage_display || null;
    },
    isChannelsActive() {
      return (this.$route?.path || '').includes('/video/channel');
    },
    filteredChannels() {
      if (!this.networkInfo || !this.networkInfo.channels) return [];
      const term = this.filterText.trim().toLowerCase();
      if (!term) return this.networkInfo.channels;
      return this.networkInfo.channels.filter(c => {
        const name = (c.name || '').toLowerCase();
        const desc = (c.description || '').toLowerCase();
        return name.includes(term) || desc.includes(term);
      });
    },
    filteredNetworks() {
      if (!this.user || !this.user.networks) return [];
      const term = this.filterText.trim().toLowerCase();
      if (!term) return this.user.networks;
      return this.user.networks.filter(n => {
        return (n.name || '').toLowerCase().includes(term);
      });
    },
    liveSummary() {
      if (!this.networkInfo || !this.networkInfo.channels) {
        return {
          count: 0,
          label: ''
        };
      }
      const liveChannels = this.networkInfo.channels.filter(c => {
        return +c.islive === 1 || +c.live === 1 || +c.livecount > 0;
      });
      return {
        count: liveChannels.length,
        label: liveChannels.length === 1 ? liveChannels[0].name : ''
      };
    },
    userDisplayName() {
      if (!this.user) return '';
      const first = this.user.firstname || this.user.firstName || '';
      const last = this.user.lastname || this.user.lastName || '';
      const full = `${first} ${last}`.trim();
      return full || this.user.name || this.user.email || 'User';
    },
    userInitials() {
      const name = this.userDisplayName.split(' ').filter(Boolean);
      if (!name.length) return 'U';
      if (name.length === 1) return name[0].charAt(0).toUpperCase();
      return (name[0].charAt(0) + name[1].charAt(0)).toUpperCase();
    }
  },
  created() {
    this.getNetworkInfo();
    this.getUserInfo();
    bus.$on('setChannel', channel => {
      if (channel !== this.channel_id) {
        bus.$emit('clearVideo');
      }
      this.channel_id = channel;
    });
    const path = this.$route?.path || '';
    if (path.includes('video/channel')) {
      if (path === '/video/channel' || path === '/video/channel/') {
        this.channel_id = 0;
      } else {
        this.channel_id = this.$route?.params?.id ?? null;
      }
    }
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    },
    async getUserInfo() {
      this.user = await UserService.getUserInfo();
    },
    getChannelLogo(channel) {
      return channel.logoimage_display || channel.profileimage_display || null;
    },
    getNetworkLogo(network) {
      return network.logoimage_display || network.profileimage_display || null;
    },
    swapnetwork(network) {
      AccountService.getNetworkSwapHash(network.userrole_id).then(response => {
        if (response.data.hash !== null && response.data.hash !== 'null') {
          const hash = response.data.hash;
          const timestamp = response.data.timestamp;
          const link = network.url + '/sso/' + network.userrole_id + '/' + hash + '/' + timestamp;
          window.location.replace(link);
        }
      });
    },
    logout() {
      if (UserService.logout) {
        UserService.logout();
      } else {
        localStorage.removeItem('user');
      }
      bus.$emit('loggedOut');
      window.location.href = '/';
    },
    submitSidebarSearch() {
      const term = (this.search || '').trim();
      if (!term) {
        this.search = '';
        window.location.href = '/video';
        return;
      }
      this.search = '';
      window.location.href = `/video?text_search=${encodeURIComponent(term)}`;
    }
  }
};